import React from 'react';
import { styled } from '../../../stitches.config';
import Html from './Html'

import { withDrawingBoard } from "../../HOCs/withDrawingBoard"

const ImgWithDesc = ({ blockData, ...props }) => {
    const { url, title, description, isImageLeft } = blockData;
    let isTitle = title !== "";
    const srcUrl = url.replace("0,0,0,0", `${window.innerWidth},0,0,0`)
    return (
        <Content isImageLeft={isImageLeft} hasTitle={isTitle}>
            <img src={srcUrl} alt="" onLoad={() => props.updateHeight()} />
            <section >
                {isTitle &&
                    <div className="imgwithdesc-title">
                        <Html html={title} />
                    </div>}
                <div className="imgwithdesc-description">
                    <Html html={description} />
                </div>
            </section>
        </Content>
    )
}

const Content = styled("div", {
    "a": {
        color: "rgb(255, 102, 0) !important",
        "&:hover": {
            textDecoration: "none"
        }
    },
    height: "auto",
    display: "flex",
    flexDirection: "column-reverse",
    "section": {
        ".imgwithdesc-title > div": {
            margin: "15px 38px",
            fontFamily: "'Playfair Display', serif",
            fontWeight: 600,
            color: "#272424",
            fontSize: "17px",
            letterSpacing: "-0.34px",
            lineHeight: "23px"
        },
        ".imgwithdesc-description div": {
            margin: "0 38px",
            color: "#262626",
            fontSize: "17px",
            fontWeight: 300,
            letterSpacing: "-0.34px",
            lineHeight: "23px"
        }
    },
    img: {
        margin: "35px 0",
        objectFit: "cover",
        width: "100%"
    },
    "@media (min-width: 992px)": {
        flexDirection: "row-reverse",
        margin: "85px 0",
        img: { margin: "0", width: "50%" },
        "section": {
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            maxWidth: "660px",
            ".imgwithdesc-title div": {
                margin: "15px auto",
                fontWeight: 400,
                fontSize: "38px",
                lineHeight: "35px",
                marginBottom: "35px"
            },
            ".imgwithdesc-description div": {
                width: "469px",
                margin: "auto",
                marginLeft: "0",
                fontSize: "18px",
                fontWeight: 400
            }
        }
    },
    variants: {
        isImageLeft: {
            true: {
                flexDirection: "column",
                "@media (min-width: 992px)": {
                    flexDirection: "row"
                }
            },
            false: {}
        },
        hasTitle: {
            true: {
                "@media (min-width: 992px)": {
                    "section": {
                        ".imgwithdesc-description div": {
                            margin: "0 auto"
                        }
                    }
                },
                false: {}
            }
        }
    }
});

export default withDrawingBoard(props => props.blockData.hasCanvas)(ImgWithDesc)